import React from 'react';

import { Footer, Possibility, OurPlans, AboutUs, Header } from './containers';
import { CTA, Brand, Navbar } from './components';

import './App.css';
import OurClasses from "./containers/ourclasses/OurClasses";

const App = () => (
  <div className="App">
    <div className="gradient__bg">
      <Navbar />
      <Header />
    </div>
    <Brand />
    <AboutUs />
    <Possibility />
    <OurPlans />
    <CTA />
    <OurClasses/>
    <Footer />
  </div>
);

export default App;
